var exports = {
  "F": "contentWrapper__h3vMmh",
};

module.exports = exports;
